<template>
  <div
    :class="
      cn('absolute bottom-0 right-1/2 translate-x-1/2 z-20 mb-4', props.class)
    "
  >
    <Transition name="slide-up">
      <div
        v-if="countSelected > 0"
        class="flex flex-col items-center justify-center"
      >
        <div class="flex gap-2 bg-white p-2 rounded-xl drop-shadow-lg">
          <Selected :count="countSelected" @clear="$emit('clear:selection')" />
          <Separator
            class="self-center border-primary border-l h-5 w-px"
            orientation="vertical"
            decorative
          />
          <div class="flex gap-1">
            <slot name="actions" />
            <slot name="quick-actions" />
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { Separator } from "radix-vue";
import { Selected } from "@/SharedComponents/BulkActions";
import { cn } from "@/Utils/cn";

defineEmits(["clear:selection"]);

const props = defineProps({
  countSelected: { type: Number, required: true },
  class: { type: null, required: false },
});
</script>
